import React from 'react';

// Exports
// -------

export default function usePendo(labUser) {
  const studentId = labUser?.activeStudent?.uuid;
  const productState = labUser?.activeUser?.productState || '';

  React.useEffect(
    function _initializePendo() {
      if (!window.pendo || !studentId) {
        return;
      }

      window.pendo.initialize({
        visitor: {
          id: studentId,
          product_state: productState,
          role: 'student',
        },
      });
    },
    [productState, studentId]
  );

  return window.pendo;
}
